import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const ContentWrapper = styled.div`
  width: 100%;
  height: 50%;
  overflow: hidden;
`;

export class ContentSplitter extends Component {
  render() {
    return (
      <Wrapper>
        {this.props.children.map((item, i) => (
          <ContentWrapper key={`content${i}`}>
            {item}
          </ContentWrapper>
        ))}
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentSplitter.js